{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "actualSituation": "Situación actual",
    "payments": "Pagos",
    "totalAmount": "Monto total",
    "currentAccount": "Cuenta corriente"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "administration-user": {
    "title": {
      "page": "Usuarios",
      "page-taxpayer": "Contribuyentes"
    },
    "label": {
      "userName": "Nombre de Usuario",
      "department": "Departamento",
      "roles": "Roles",
      "user": "Nuevo usuario",
      "disabled": "Deshabilitado",
      "locale": "Lenguaje de preferencia",
      "disable": "Deshabilitar",
      "enable": "Habilitar",
      "cancel": "Cancelar"
    },
    "validations": {
      "userName": "Nombre del usuario es requerido"
    },
    "messages": {
      "disableTitle": "Deshabilitar usuario",
      "confirmDisable": "¿Esta seguro que desea deshabilitar este usuario?",
      "confirmEnable": "¿Esta seguro que desea habilitar este usuario?",
      "savedSucessfully": "Salvado satisfactoriamente",
      "enableTitle": "Habilitar usuario",
      "error": "Error"
    }
  },
  "user-profile": {
    "title": {
      "page": "Perfil de Usuario",
      "change-password": "Cambiar Contraseña"
    },
    "label": {
      "userName": "Nombre de Usuario",
      "name": "Nombre",
      "email": "Correo",
      "locale": "Idioma Preferido",
      "currentPassword": "Contraseña Actual",
      "newPassword": "Nueva Contraseña",
      "repeatPassword": "Repetir Contraseña",
      "change-password": "Cambiar Contraseña",
      "password": "Contraseña"
    },
    "message": {
      "password-changed": "Contraseña modificada satisfactoriamente",
      "profile-updated": "Perfil actualizado satisfactoriamente. Debe hacer login nuevamente para ver los cambios",
      "password": "Actualiza la contraseña de tu cuenta para mantenerla segura"
    }
  },
  "common": {
    "label": {
      "theme": "Tema",
      "captcha-placeholder": "Ingrese Captcha",
      "feedback": "Comentarios",
      "logout": "Salir",
      "print": "Imprimir",
      "phoneNumberArea": "Área",
      "current-user": "Usuario actual",
      "user-profile": "Perfil de usuario",
      "name": "Nombre",
      "givenNames": "Nombres",
      "surnames": "Apellidos",
      "search": "Buscar",
      "clean": "Limpiar",
      "create": "Nuevo",
      "ok": "Aceptar",
      "next": "Siguiente",
      "cancel": "Cancelar",
      "back": "Atrás",
      "edit": "Editar",
      "actions": "Acciones",
      "send": "Enviar",
      "close": "Cerrar",
      "add": "Agregar",
      "email": "Correo",
      "phoneNumber": "Teléfono",
      "id": "Id",
      "password": "Contraseña",
      "state": "Deshabilitado",
      "translation": "Traducción",
      "language": "Idioma",
      "value": "Valor",
      "translatable": "Traducible",
      "politicalDivision": "División Política",
      "department": "Departamento / Provincia / Estad",
      "city": "Ciudad",
      "zipCode": "Código Postal",
      "cellPhone": "Celular",
      "personType": "Tipo de Persona",
      "businessName": "Nombre o razón social",
      "taxpayerName": "Nombre o razón social",
      "tradeName": "Nombre comercial",
      "address": "Dirección comercial",
      "country": "País",
      "localization": "Ubicación",
      "website": "Sitio Web",
      "fileSearch": "Buscar Archivo",
      "fileUpload": "Subir Archivo",
      "fileDownload": "Descargar Archivo",
      "noFileSelected": "Sin Archivo Elegido",
      "fileRequirements": "PDF · Máx. 9.6 MB",
      "fileUploading": "Subiendo...",
      "fileUploaded": "Cargado",
      "fileUploadError": "No se pudo cargar el archivo",
      "fileSelect": "Seleccionar",
      "fileReplace": "Reemplazar",
      "fileRemove": "Quitar",
      "fileRemoving": "Eliminando...",
      "fileRemoveError": "No se pudo eliminar el archivo",
      "dateFrom": "Fecha desde",
      "dateTo": "Fecha hasta",
      "noFound": "No hay ningún resultado",
      "taxReturnCurrency": "Moneda Declaración",
      "page-showing": "Mostrando",
      "page-to": "a",
      "page-of": "de",
      "page-entries": "registros",
      "loading": "Cargando...",
      "error": "Error",
      "unableToLoad": "No se pudieron cargar los datos. Inténtelo de nuevo.",
      "retry": "Reintentar",
      "currency": "Moneda",
      "paymentMethod": "Método de pago",
      "attachment": "Adjunto",
      "paymentReference": "Información complementaria",
      "supportDocument": "Documento de soporte",
      "payment": "Pago",
      "backToHome": "Volver al inicio",
      "bank": "Banco",
      "bankInformation": "Información bancaria",
      "excel": "Excel",
      "days": {
        "monday": "Lu",
        "tuesday": "Ma",
        "wednesday": "Mi",
        "thursday": "Ju",
        "friday": "Vie",
        "saturday": "Sá",
        "sunday": "Do"
      },
      "months": {
        "january": "Enero",
        "february": "Febrero",
        "march": "Marzo",
        "april": "Abril",
        "may": "Mayo",
        "june": "Junio",
        "july": "Julio",
        "august": "Agosto",
        "september": "Septiembre",
        "october": "Octubre",
        "november": "Noviembre",
        "december": "Diciembre"
      }
    },
    "descriptions": {
      "taxReturnCurrency": "Moneda que se usará para las declaraciones",
      "contactTaxIdNumber-tax": "Número de identificación tributario del contacto en el país de residencia"
    },
    "button": {
      "add": "Agregar",
      "edit": "Editar",
      "find": "Buscar",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "save": "Guardar",
      "submitTaxReturn": "Presentar declaración tributaria",
      "clean": "Limpiar",
      "new": "Nuevo",
      "show": "Ver",
      "download": "Descargar",
      "file": "Adjunto",
      "previous": "Anterior",
      "next": "Siguiente",
      "send": "Enviar",
      "translate": "Traducciones",
      "return": "Volver",
      "continue": "Continuar",
      "newVersion": "Nueva Versión"
    },
    "dialog": {
      "dialog-error": "Errores",
      "table-title-header": "Mensajes",
      "warning-title": "Atención"
    },
    "messages": {
      "error-500": "Ha ocurrido un error en la operación",
      "fileUpload": "El archivo ha sido subido de forma exitosa",
      "fileUploadMaxSize": "Tamaño del documento no puede exceder 10Mb",
      "savedSucessfully": "Almacenado de forma exitosa",
      "deletedSucessfully": "Eliminado de forma exitosa",
      "pleaseWait": "Por favor espere",
      "warningInactiveSession": "Atención: No se ha detectado actividad en un tiempo. En 1 minuto se cerrará la sesión si aún no se detecta actividad",
      "sessionIdleCountdown": "Su sesión se cerrará en {{count}} segundos.",
      "closingSession": "Cerrando Sesión ...",
      "warningCancelOperation": "Si cancela la operación perderá los datos ingresados, ¿Desea continuar?",
      "confirm": "¿Estas seguro que quieres realizar esta acción?",
      "feedback": "Gracias por sus comentarios",
      "feedbackIntro": "Sus comentarios serán enviados a la Administración para conocer su experiencia con el sistema y poder brindarle un mejor servicio.",
      "messageSent": "Mensaje enviado con éxito"
    },
    "validations": {
      "nameRequired": "El campo Nombre es requerido",
      "fieldRequired": "El campo es requerido",
      "mapRequired": "Debe seleccionar una posición en el mapa",
      "numbersAndLetters": "Sólo números y letras",
      "email": "Correo inválido",
      "minStringValue": "Campo debe ser mínimo {{min}} caracteres",
      "maxStringValue": "Campo debe ser máximo {{max}} caracteres",
      "minNumberValue": "Valor del campo debe ser mínimo {{min}}",
      "maxNumberValue": "Valor del campo debe ser máximo {{max}}",
      "urlInvalid": "Formato de la Url es inválido",
      "captchaValidationRequired": "Validación de captcha es requerida"
    },
    "languages": {
      "spanish": "Spanish (Spain)",
      "english": "English (United States)"
    },
    "taxpayer-request-types": {
      "enroll": "Registro",
      "update": "Actualización"
    },
    "taxpayer-request-states": {
      "pending": "Pendiente",
      "pending_additional_information": "Pendiente por Información Adicional",
      "approved": "Aprobada",
      "rejected": "Rechazada"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Rectificativa"
    },
    "taxreturn-status": {
      "pending": "Pendiente",
      "accepted": "Aceptada",
      "approved": "Aprobada",
      "rejected": "Rechazada",
      "reconciled": "Conciliado"
    },
    "yes-no": {
      "yes": "Sí",
      "no": "No"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Tipo de catálogo",
      "catalog": "Catálogo "
    },
    "label": {
      "type": "Tipo",
      "name": "Nombre",
      "description": "Descripción",
      "field": "Campo",
      "label": "Etiqueta",
      "parent": "Padre",
      "newCatalogType": "nuevo tipo de catálogo",
      "newCatalog": "Nuevo catálogo",
      "code": "Código ",
      "addDefinition": "Añadir definición",
      "newDefinition": "Nueva definición",
      "extaFilds": "Campos adicionales del usuario",
      "addNameTraslation": "Añadir traducción"
    },
    "validations": {
      "exists": "El registro ya existe",
      "letterNumberhyphen": "Solo letas, numero y guiones son permitidos"
    },
    "messages": {
      "languageExist": "El lenguaje ya fue añadido"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Campos Contribuyente",
      "enabled": "Habilitado"
    },
    "header": {
      "fieldCode": "Código",
      "fieldName": "Nombre",
      "fieldSection": "Sección",
      "actions": "Habilitado"
    },
    "messages": {
      "savedSucessfully": "Información almacenada exitosamente"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconectando",
      "reconected": "Reconectado"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Cuenta corriente",
      "amendingCredit": "Consulta de saldo",
      "currentAccountTransaction": "Detalle de transacciones",
      "transactionAdjustment": "Ajuste de saldo"
    },
    "label": {
      "tax": "Impuesto",
      "taxCode": "Cod. Impuesto",
      "period": "Periodo",
      "taxAmount": "Monto de impuesto",
      "penalty": "Multa",
      "interest": "Intereses",
      "taxArrears": "Mora",
      "total": "Total",
      "expirationDate": "Fecha Vencimiento",
      "accountType": "Tipo de cuenta",
      "balance": "Saldo",
      "date": "Fecha",
      "transactionType": "Tipo de transacción",
      "value": "Valor",
      "document": "Documento",
      "justification": "Justificación",
      "credit": "Crédito",
      "debit": "Débito"
    },
    "dialog": {},
    "messages": {},
    "validations": {}
  },
  "taxpayer-payments": {
    "title": {
      "page": "Consulta de pago",
      "pagePayments": "Registro de pago",
      "selectTaxReturn": "Seleccione Declaración de impuestos"
    },
    "label": {
      "registerPayment": "Registro de pago",
      "amountTaxReturn": "Monto de la declaración",
      "totalDebt": "Deuda total",
      "tax-id": "Ruc",
      "name": "Nombre",
      "date-from": "Fecha desde",
      "date-to": "Fecha hasta",
      "date-payment": "Fecha de pago",
      "payment-number": "Número de pago",
      "exchange-rate": "Tipo de cambio",
      "local-amount": "Monto en moneda local",
      "tax": "Impuesto",
      "amount": "Monto",
      "swiftNumber": "Número de confirmación SWIFT"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Pago registrado satisfactoriamente el [createDate]",
      "paymentInformationWarning": "Si no se facilita la información relativa al código Swift, el pago no podrá identificarse correctamente y la declaración se considerará impaga."
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Consulta de contribuyentes"
    },
    "label": {
      "name": "Nombre",
      "nit": "RUC",
      "county": "País",
      "personType": "Tipo de persona",
      "email": "Correo"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Tipo persona",
      "businessName": "Nombre o razón social",
      "fullName": "Nombre completo",
      "id": "Número de identificación",
      "taxNumber": "Número de identificación tributaria en el país de residencia",
      "phoneNumber": "Número de teléfono",
      "domicile": "Domicilio",
      "department": "Departamento/Provincia/Estado",
      "addContact": "Añadir contacto",
      "operations": "Operaciones",
      "contacts": "Contactos",
      "taxVector": "Vector fiscal",
      "reportVector": "Reportes",
      "generalData": "Generales",
      "tax": "Impuesto",
      "taxObligation": "Impuesto",
      "report": "Reporte",
      "website": "Sitio web",
      "idTax": "Número de identificación tributario en el país de residencia",
      "contactName-tax": "Nombre del contacto principal",
      "docNumberContact-tax": "Número de identificación del contacto",
      "contactTaxIdNumber-tax": "Número de identificación tributario del contacto en el país de residencia",
      "phoneNumberContact-tax": "Número de teléfono del contacto en el país de residencia",
      "email-tax": "Correo del contacto",
      "documents": "Documentos",
      "docCompanyRegistrationNumber": "Documento de registro de la empresa",
      "docLocalContact": "Documento de identidad del contacto en el país de residencia",
      "acceptance": "Aceptación",
      "taxpayerRequest": "Registro en POSS",
      "confirmTerms": "Aceptar términos y condiciones",
      "terms": "Lorem ipsum dolor sit amet consectetur adipiscing elit per, penatibus euismod ac libero praesent sollicitudin lacinia nulla platea, nam hac cursus cubilia congue luctus dapibus. Iaculis luctus egestas accumsan eleifend metus dis aptent quisque, lacus vitae nullam habitasse ad mollis tempor, mattis ornare dapibus laoreet auctor tellus dui. Ante integer sagittis erat accumsan vulputate potenti senectus, rutrum ullamcorper nam hendrerit ridiculus faucibus, parturient fames ligula venenatis tristique inceptos.\n\nCum aliquet tempor cras non potenti inceptos aptent, mauris scelerisque mollis auctor libero porta id ut, sodales vulputate eget imperdiet netus posuere. Iaculis dignissim himenaeos magna luctus nulla egestas porttitor, eros vulputate volutpat sociosqu quisque mollis donec, class placerat justo vivamus imperdiet accumsan. Ultrices facilisi phasellus augue cursus etiam viverra suspendisse est, nam vulputate tempor posuere dignissim feugiat sed hac sodales, diam tristique pretium auctor ad erat sem. Et enim gravida magnis malesuada nam nascetur fermentum, proin platea elementum nec penatibus ultricies, blandit cubilia aptent neque praesent sociis.\n\nSagittis augue enim nam sociis, ornare est mi himenaeos, risus proin sodales. Proin malesuada integer aliquam cubilia neque natoque velit, feugiat elementum quis quisque suscipit fermentum conubia, nisi a ligula duis sapien tellus. Praesent mattis fringilla habitant nulla sollicitudin bibendum habitasse at cum quis mus iaculis mi magna sodales, velit hendrerit inceptos dictum neque montes turpis tellus nam morbi commodo nullam senectus.\n\nArcu primis eu conubia fusce nisi vehicula posuere leo sollicitudin eleifend, phasellus sodales congue ligula consequat volutpat magnis facilisi curabitur maecenas, et dis velit libero hac proin habitant sociis nascetur. Nunc tortor penatibus mi ultrices risus nec elementum justo, mattis ad ac tempus vel habitasse accumsan sed parturient, lectus lacinia conubia malesuada volutpat egestas nulla. Himenaeos consequat vitae class mattis taciti nec habitant eleifend, elementum netus eget parturient suspendisse porttitor in felis maecenas, curabitur morbi odio gravida vivamus per bibendum.\n\nTortor non sociosqu accumsan orci vel ligula risus nisl, penatibus odio magnis ullamcorper pellentesque habitant lacinia consequat, aptent nec congue nisi egestas sociis quam. Turpis sociis eu est parturient in fames aliquet nisl, dui natoque phasellus aliquam posuere curae aptent porta, tortor condimentum molestie netus cubilia inceptos lacinia. Auctor laoreet purus nostra dapibus sollicitudin tincidunt dictum nisl lacinia erat, est rhoncus fusce phasellus blandit etiam inceptos suspendisse magna, duis pellentesque nam hac neque mus dignissim a enim.\n\nNeque proin felis laoreet senectus nullam netus sollicitudin odio tincidunt, penatibus parturient facilisis porta duis sagittis malesuada varius sociosqu congue, aptent velit pellentesque mauris egestas nibh semper orci. Dis sociosqu at torquent nec commodo erat eu pharetra natoque, senectus velit nascetur curae sollicitudin mus phasellus. Aenean diam ut nibh vulputate neque fusce penatibus class porta mattis imperdiet risus ante, ac lectus habitasse posuere facilisis luctus varius mus tempus non mollis.\n\nDictumst eleifend vehicula purus hendrerit volutpat primis integer, per senectus fusce nulla cubilia dictum feugiat auctor, ultricies sociosqu nisl mi class magnis. Ligula himenaeos phasellus pulvinar accumsan platea egestas sodales hendrerit sagittis augue, curae nec molestie pretium cum parturient lacus euismod sociosqu ullamcorper duis, dignissim fusce libero maecenas congue lobortis penatibus nisi justo.\n\nCum rutrum vehicula convallis pellentesque maecenas nascetur proin congue platea, posuere neque facilisi ullamcorper nibh curae sodales non, cursus nisl cras morbi interdum vitae auctor cubilia. Ligula taciti enim donec congue bibendum fusce eros rhoncus suscipit, dui parturient potenti odio sapien non erat eget, tincidunt convallis primis quam tortor consequat sodales per. Neque hendrerit erat nunc hac ullamcorper molestie fermentum, tristique ultrices sociis vivamus volutpat lectus, vestibulum vehicula aenean mattis magna posuere. Justo condimentum tempor taciti laoreet inceptos per hendrerit eleifend consequat lacus nostra enim, convallis praesent dui faucibus lobortis quam pharetra odio mauris duis.\n\nMagna ultrices dui netus laoreet odio rhoncus maecenas nec placerat rutrum, massa duis nam nulla velit quis fringilla habitasse. Eu integer diam lectus ullamcorper torquent ante aliquet cras feugiat inceptos placerat ut, porta libero nam mauris volutpat habitasse iaculis lacinia facilisi hendrerit nostra.\n\nLaoreet risus nisi sociosqu inceptos maecenas blandit phasellus bibendum, nostra velit fringilla tristique mus donec lectus semper, est tortor nascetur curae scelerisque himenaeos sagittis. Quam volutpat eros non nec nascetur justo, velit tristique nisl arcu est, ultricies sapien convallis metus vulputate. Condimentum justo ad varius habitant nunc gravida sed vivamus, maecenas ut congue aenean ligula proin lectus, natoque urna duis dui semper egestas habitasse.\n\nAnte et luctus porta malesuada accumsan cursus senectus dictumst penatibus pretium nullam, id condimentum proin felis aliquam sollicitudin varius velit lobortis class placerat, praesent ridiculus eget nisl metus tristique maecenas semper himenaeos parturient. Enim laoreet vulputate orci dui lectus purus bibendum vivamus posuere est curabitur, cubilia fames nulla porta in scelerisque cursus nunc a ligula pretium dictum, mi molestie pulvinar torquent litora vitae fusce eget curae sem. Dapibus quam facilisi cras pharetra mus curabitur, parturient a malesuada integer vitae etiam suspendisse, fermentum massa libero curae neque.",
      "locale": "Lenguaje predefinido",
      "close": "Salir",
      "acquirerId": "Identificación del adquirente",
      "acquirerCountry": "País del adquirente",
      "terminalId": "Identificación del terminal",
      "merchantCategoryCode": "Código de categoría del comerciante",
      "merchantId": "Identificación del comerciante",
      "documentNumberCountryResidence": "Número de documento en el país de residencia"
    },
    "vector": {
      "label": {
        "tax": "Impuesto",
        "expiration": "Dia de expiración",
        "periodicity": "Periodicidad",
        "startOperation": "Inicio de operación"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Se requiere un mayor número de contactos",
      "operations": "Al menos una operación es requerida ",
      "selectOperations": "Seleccione las operaciones correspondientes",
      "withoutOperations": "Sin operaciones",
      "withoutOperationsVector": "Por sus operaciones seleccionadas no tiene vector fiscal que presentar",
      "withoutOperationsReport": "Por sus operaciones seleccionadas no tiene reportes que presentar",
      "withoutDocuments": "No existe ninguna definición de archivos",
      "successRegistrationTaxpayerTitle": "Su solicitud de registro ha sido completada y recibida con éxito.",
      "successRegistrationTaxpayerSubTitle": "Será analizado y recibirá sus resultados por correo electrónico.",
      "email-tax-info": "Este correo será utilizado para recibir su usuario y contraseña una vez aprobada su solicitud. Por favor verifique la información provista sea correcta",
      "contactsList": "Registro aquí sus contactos secundarios. Debe registrar al menos uno",
      "noContacts": "No se han registrado contactos"
    },
    "validations": {
      "acceptance": "Campo debe ser seleccionado",
      "formComplete": "Completa todo el formulario"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Solicitudes de Contribuyentes",
      "approve": "Aprobar Solicitud",
      "reject": "Rechazar Solicitud",
      "request-additional-info": "Solicitar Información Adicional",
      "cancellationDate": "Cancellation date"
    },
    "label": {
      "date-from": "Fecha Desde",
      "date-to": "Fecha Hasta",
      "request-type": "Tipo de Solicitud",
      "request": "Solicitud",
      "type": "Tipo",
      "taxpayer": "Contribuyente",
      "state": "Estado",
      "approve": "Aprobar",
      "reject": "Rechazar",
      "request-additional-info": "Solicitar Información Adicional",
      "comments": "Comentarios",
      "reason": "Causa",
      "cancellationDate": "Fecha de cancelación"
    },
    "message": {
      "approved": "Solicitud Aprobada",
      "rejected": "Solicitud Rechazada",
      "request-additional-info": "Solicitud de información adicional",
      "unsubscribe-request": "Su solicitud ha sido recibida, se le notificará si su solicitud fue aprobada o rechazada."
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Ver declaraciones",
      "subtitle": "Lista de documentos almacenados",
      "amendment": "Presentar una declaración de impuestos rectificativa"
    },
    "label": {
      "nit": "Ruc",
      "taxreturnNumber": "Número Declaración",
      "country": "País",
      "formId": "Nombre de Formulario",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "name": "Nombre Contribuyente",
      "period": "Periodo",
      "periodFrom": "Fecha Desde",
      "periodTo": "Fecha Hasta",
      "active": "Activa",
      "overview": "General",
      "taxreturn": "Declaración",
      "createDate": "Fecha",
      "approve": "Aprobado",
      "comments": "Comentarios"
    },
    "header": {
      "actions": "Acciones",
      "nit": "Ruc",
      "name": "Nombre Contribuyente",
      "taxReturnNumber": "Número Declaración",
      "createDate": "Fecha",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "form": "Formulario",
      "period": "Periodo",
      "active": "Activa",
      "rejectionReason": "Motivo de rechazo"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Actualizar registro"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Darse de Baja"
    }
  },
  "report-file": {
    "title": {
      "page": "Adjunto de Informe complementario",
      "dialog": "Informe ya existe",
      "dialog-confirm": "Enviar Informe"
    },
    "label": {
      "header": "Cabecera",
      "description": "Descripción",
      "type": "Tipo",
      "file": "Informe complementario",
      "loading": "Cargando...",
      "definition": "Definición archivo (.csv,.xls,.xlsx) "
    },
    "button": {
      "attachment": "Adjuntar informe"
    },
    "messages": {
      "dialog": "Ya se ha presentado un informe para el periodo seleccionado, ¿Desea sustituir el informe existente por una nueva versión?",
      "confirm": "¿Estas seguro que quieres realizar esta acción?",
      "successfully": "Informe complementario con periodo [period] fue enviado satisfactoriamente el [createDate]",
      "backToHome": "Volver al Inicio"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Procesando",
      "error": "Error",
      "accepted": "Aceptado",
      "processed": "Procesado"
    },
    "title": {
      "page": "Consulta de informes"
    },
    "label": {
      "reportNumber": "Numero de reporte",
      "reportType": "Tipo de reporte",
      "operations": "Tipo de operación",
      "taxpayerNumber": "Numero de identificación tributaria",
      "reportName": "Nombre de el reporte",
      "record": "Valores",
      "index": "Fila",
      "period": "Período",
      "registrationDate": "Fecha Registro",
      "type": "Tipo",
      "active": "Activo",
      "taxReportState": "Estado"
    }
  },
  "report-selection": {
    "label": {
      "fileReport": "Presentar informe complementario",
      "report": "Reporte",
      "year": "Periodo"
    },
    "messages": {
      "reportVersionNotFound": "No se encontro la versión del reporte"
    }
  },
  "taxreturn-report": {
    "title": {
      "page": "Consulta Declaraciones"
    },
    "label": {
      "nit": "Ruc",
      "taxreturnNumber": "Número Declaración",
      "country": "País",
      "formId": "Formulario",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "name": "Nombre Contribuyente",
      "period": "Periodo",
      "periodFrom": "Fecha Desde",
      "periodTo": "Fecha Hasta",
      "active": "Activa",
      "overview": "General",
      "taxreturn": "Declaración",
      "createDate": "Fecha",
      "approve": "Aprobado",
      "comments": "Comentarios"
    },
    "header": {
      "actions": "Acciones",
      "nit": "Ruc",
      "name": "Nombre Contribuyente",
      "taxReturnNumber": "Número Declaración",
      "createDate": "Fecha",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "form": "Formulario",
      "period": "Periodo",
      "active": "Activa",
      "rejectionReason": "Motivo de rechazo"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "form-cells": {
    "title": {
      "page": "Casillas",
      "serviceParameters": "Parámetros de Servicio"
    },
    "label": {
      "code": "Código Casilla",
      "name": "Nombre Casilla",
      "description": "Descripción",
      "section": "Sección",
      "formula": "Fórmula",
      "order": "Orden",
      "type": "Tipo",
      "service": "Servicio",
      "mandatory": "Obligatorio",
      "editable": "Editable",
      "visible": "Visible",
      "cellPurpose": "Propósito de la celda",
      "numeric": "Numérica",
      "currency": "Moneda",
      "date": "Fecha",
      "list": "Lista",
      "text": "Texto",
      "catalogType": "Tipo Catálogo",
      "parameterName": "Nombre",
      "addParameter": "Agregar Parámetro"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿Está seguro de eliminarlo?"
    }
  },
  "amendment-create": {
    "title": {
      "dialog-confirm": "Enviar Declaración"
    },
    "label": {
      "taxReturn": "Numeró de declaración a rectificar"
    },
    "messages": {
      "confirm": "¿Estas seguro que quieres realizar esta acción?"
    }
  },
  "statement-submit-amendment": {
    "title": {
      "page": "Rectificar declaración"
    },
    "label": {
      "taxReturn": "Declaración",
      "year": "Periodo"
    },
    "messages": {},
    "validations": {},
    "button": {
      "file": "Rectifar"
    }
  },
  "statement-submit-statement": {
    "title": {
      "page": "Presentar declaración de impuestos",
      "subtitle": "Por favor, complete la información para identificar el impuesto y el período que se va a declarar"
    },
    "label": {
      "fileStatement": "Presentar declaración de impuestos",
      "taxReturn": "Declaración de impuestos",
      "year": "Periodo"
    },
    "messages": {
      "formVersionNotFound": "No se encontro una versión vigente y activa",
      "taxReturnExist": "La declaración ya existe para este período",
      "validPeriod": "El periodo seleccionado no está vigente para este impuesto"
    }
  },
  "taxreturns": {
    "title": {
      "dialog-confirm": "Enviar Declaración"
    },
    "messages": {
      "successfully": "Declaración con periodo [period] fue enviada satisfactoriamente el [createDate]",
      "successfullyApprovalRequired": "Debido a que la declaración rectificativa ha disminuido el impuesto, la misma será sometida a un proceso de revisión para su aprobación o rechazo por parte de la administración tributaria.",
      "confirm": "¿Estas seguro que quieres realizar esta acción?",
      "backToHome": "Volver al Inicio"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Buzon"
    },
    "label": {
      "message": "Mensaje",
      "messages": "Mensajes",
      "read": "Leido",
      "inboxDate": "Fecha",
      "ok": "SI",
      "no": "NO"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Api Keys"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Nueva Llave",
      "expiration": "Fecha de Expiración",
      "your-pat": "Su nuevo Personal Access Token",
      "revoke-token": "Revocar Token"
    },
    "validations": {
      "name": "Nombre del Api Key es requerida",
      "expiration": "Fecha de expiración es requerida"
    },
    "message": {
      "key-created": "Asegúrese de guardarla - no podrá acceder a ella nuevamente.",
      "confirm-revoke": "¿Está seguro que desea revocar el token?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Logs de Eventos",
      "command-title": "Logs de Acciones",
      "query-title": "Logs de Consultas",
      "application": "Aplicación",
      "security": "Seguridad"
    },
    "label": {
      "dateFrom": "Fecha Desde",
      "dateTo": "Fecha Hasta",
      "user": "Usuario",
      "commandName": "Nombre de el comando",
      "successfullyExecuted": "Ejecución Exitosa",
      "queryName": "Nombre Consulta",
      "aggregateName": "Nombre Entidad",
      "eventName": "Nombre Evento",
      "httpMethod": "Método Http",
      "httpStatusCode": "Código de estado Http"
    },
    "header": {},
    "validations": {
      "dateRequired": "Esta fecha es requerida",
      "dateToGreaterThan": "La fecha debe ser mayor a la Fecha Desde",
      "dateLessThreeMonths": "La fecha deber ser menor a 3 meses desde la Fecha Desde"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Deshabilitar doble factor de autenticación (2FA)",
      "disable": "Deshabilitar 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "This action only disables 2FA.",
      "alert-2": "Al deshabilitar 2FA no se cambian las llaves usadas en la apps autenticadoras.",
      "alert-3": "Si desea cambiar la llave usada en una app autenticadora usted debe:",
      "alert-4": "reiniciar sus llaves autenticadoras.",
      "success": "2fa ha sido deshabilitado. Puede rehabilitar el 2fa cuando haga setup de una app autenticadora"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configurar app autenticadora",
      "verification-code": "Código de Verificación",
      "verification-code-digit": "Dígito {{position}} de {{total}}",
      "verify": "Verificar",
      "manual-key": "Clave de configuración manual",
      "copy-key": "Copiar clave",
      "key-copied": "Clave copiada al portapapeles.",
      "key-copied-button": "Copiado",
      "copy-unavailable": "No fue posible copiar la clave. Cópiela manualmente.",
      "security-recommendations": "Recomendaciones de seguridad",
      "security-recommendations-detail": "Conserve los códigos de recuperación en un lugar seguro y no comparta la clave de configuración."
    },
    "validations": {
      "code": "Código de Verificación es requerido"
    },
    "message": {
      "instruction-1": "Descargue una authenticator app como Microsoft Authenticator para",
      "and": "y",
      "or": "o",
      "for": "para",
      "instruction-2": "Escanee el código QR o introduzca esta llave",
      "instruction-3": "dentro de su authenticator app. Los espacios y separadores no importan.",
      "instruction-4": " Una vez escaneado el código QR o ingresada la llave de arriba, su authentication app le proveerá un código único. Introduzca el código en el campo de confirrmación de abajo."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Códigos de Recuperación",
      "available-once": "Guárdelos ahora: no volverán a mostrarse completos."
    },
    "message": {
      "save-security-codes": "Guarde estos códigos en un lugar seguro.",
      "if-you-lose": "Si pierde su dispositivo y no tiene los códigos de recuperación, perderá acceso a su cuenta."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Generar códigos de recuperación para autenticación con doble factor (2FA)",
      "generate": "Generar Códigos de Recuperación"
    },
    "validations": {},
    "message": {
      "alert-1": "Coloque estos códigos en un lugar seguro.",
      "alert-2": " Si pierde su dispositivo y no tiene los códigos de recuperación, perderá acceso a su cuenta.",
      "alert-3": "Generar nuevos códigos de recuperación no cambia las llaves usadas en el authenticator app. Si desea cambiar la llave usada en el authenticator app, debe",
      "alert-4": " reiniciar su llaves de autenticación."
    }
  },
  "security-login": {
    "title": {
      "login": "Login"
    },
    "label": {
      "username": "Usuario",
      "password": "Contraseña",
      "rememberMe": "Recuérdame",
      "loginButton": "Iniciar sesión ",
      "passwordRecovery": "Recuperar contraseña",
      "notRegistered": "¿ No estas registrado aún ?",
      "signup": "Regístrate",
      "loginAlternative": "o",
      "forgotPassword": "¿ Olvidaste tu contraseña ?",
      "next": "Siguiente",
      "forgotPasswordInstructions": "Ingresa tu usuario y te enviaremos un correo con las instrucciones para recuperar",
      "externalLogin": "Login Externo",
      "captcha-placeholder": "Ingrese Captcha"
    },
    "validations": {
      "usernameRequired": "El campo usuario es requerido",
      "passwordRequired": "La contraseña es requerida",
      "captchaValidationRequired": "Validación de captcha es requerida"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Autenticación de doble factor",
      "login-recovery": "Recuperar codigo de verificación"
    },
    "label": {
      "twoFactorCode": "Codigo autenticador",
      "recoveryCode": "Codigo de recuperación",
      "rememberBrowser": "Recordar este navegador",
      "verificationCodeInstructions": "Ingrese el código de seis dígitos de su aplicación autenticadora para continuar.",
      "loginButton": "Inicio de sesión",
      "loginRecovery": "Inicio de sesión con el codigo de recuperación"
    },
    "message": {
      "no-access": "No tienes acceso a tu dispositivo de autenticación? puedes",
      "trustedBrowser": "Omita la verificación en este navegador de confianza.",
      "recovery-requested": " Ha solicitado iniciar sesión con un código de recuperación. Este inicio de sesión no se recordará hasta que proporcione un código de aplicación de autenticación al iniciar sesión o desactive 2FA y vuelva a iniciar sesión."
    },
    "validations": {
      "twoFactorCode": "El campo codigo autenticación es requerido",
      "recoveryCode": "El campo codigo de recuperación es requerido"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Recuperar contraseña",
      "changePassword": "Cambiar contraseña",
      "userName": "Usuario",
      "newPassword": "Nueva contraseña",
      "repeatPassword": "Repetir contraseña",
      "returnLogin": "Regresar al inicio de sesión "
    },
    "message": {
      "email-sended": "Recuperación de contraseña correo enviado",
      "password-changed": "Se ha cambiado la contraseña satisfactoriamente"
    },
    "validations": {
      "newPassword": "La nueva contraseña debe tener al menos 6 carateres",
      "passwordEqual": "Las contraseña no coinciden"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Instalar authenticator app",
      "reset": "Reiniciar authenticator key",
      "configure": "Configurar authenticator app"
    },
    "validations": {},
    "message": {
      "alert-1": "Si reinicia su llave autenticadora su authenticator app no funcionará hasta que la reconfigure.",
      "alert-2": "Este proceso deshabilita 2FA hasta que verifique su authenticator app.",
      "alert-3": "Si no completa la configuración de su authenticator app podría perder acceso a su cuenta.",
      "success": "Su llave autenticadora ha sido reiniciada, y deberá configurar su authenticator app usando la nueva llave."
    }
  },
  "tfa": {
    "title": {
      "page": "Autenticación con Doble Factor"
    },
    "label": {
      "title": "Autenticación con Doble Factor (2FA)",
      "authenticator-app": "Authenticator app",
      "setup-authenticator": "Configurar authenticator app",
      "add-authenticator": "Añadir authenticator app",
      "reset-authenticator": "Reiniciar authenticator app",
      "reset-recovery-codes": "Reiniciar códigos de recuperación",
      "disable-2fa": "Deshabilitar 2FA",
      "forget-this-browser": "Olvidar este navegador",
      "status-enabled": "Activo",
      "status-disabled": "No configurado",
      "recovery-codes-remaining": "códigos de recuperación disponibles",
      "danger-zone": "Acciones de alto impacto"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Este navegador ha sido olvidado. Cuando haga login nuevamente en este navegador se le solicitará su código 2fa.",
      "no-codes-left-1": "No tiene códigos de recuperación disponibles.",
      "no-codes-left-2": "Debe",
      "no-codes-left-3": "generar un nuevo set de códigos de recuperación",
      "no-codes-left-4": "antes de que pueda hacer login con un código de recuperación.",
      "some-codes-left-1": "Tiene ",
      "some-codes-left-2": "código(s) de recuperación disponible(s).",
      "some-codes-left-3": "Debe ",
      "some-codes-left-4": "generar un nuevo set de códigos de recuperación"
    }
  },
  "roles": {
    "account_reports": "Consulta de Cuentas",
    "catalogs_admin": "Administrador de Catálogos",
    "details_reports": "Detalle de Reportes",
    "environments_admin": "Administrador de Variables de Entorno",
    "forms_admin": "Administrador de Formularios",
    "management_report_admin": "Administrador de Reportes",
    "notifications_admin": "Administrador de Notificaciones",
    "system_auditor": "Auditor de Sistema",
    "taxpayer_reports": "Consultas de Contribuyente",
    "taxpayers_admin": "Administrador de Contribuyentes",
    "payments_admin": "Administrador de Pagos",
    "taxpayers_approver": "Aprobador de Contribuyentes",
    "taxreturn_approver": "Aprobador de Declaraciones",
    "taxreturn_reports": "Consultas de Declaraciones",
    "tfa_admin": "Administrador de 2FA",
    "users_admin": "Administrador de Usuarios",
    "current_account_admin": "Administrador de Cuenta Corriente"
  },
  "taxes": {
    "title": {
      "page": "Administrar Impuestos"
    },
    "label": {
      "name": "Nombre",
      "rateType": "Tipo Tasa",
      "shortName": "Nombre corto",
      "code": "Código",
      "newButton": "Nuevo",
      "saveButton": "Guardar",
      "tabEditTax": "General",
      "tabRates": "Tasas",
      "tabPeriodicity": "Periodicidad",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "value": "Valor",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración"
    },
    "header": {
      "code": "Código",
      "name": "Nombre",
      "rateType": "Tipo Tasa",
      "value": "Valor",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "shortName": "Nombre corto",
      "actions": "Acciones",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración"
    },
    "validations": {
      "rate TypeRequired": "El campo tipo de tasa es requerido",
      "shortNameRequired": "El campo nombre corto es requerido",
      "codeRequired": "El campo código es requerido",
      "valueLessThan100": "El campo valor debe ser menor al 100%",
      "valueRequired": "El campo valor es requerido",
      "dateFromRequired": "El campo fecha desde es requerido",
      "dateToRequired": "El campo fecha hasta es requerido",
      "filingDueDayRequired": "El campo día expiración es requerido",
      "periodicityTypeRequired": "El campo tipo periodicidad es requerido"
    },
    "messages": {
      "savedSuccessfully": "Se guardó correctamente",
      "deletedSuccessfully": "Se eliminó correctamente",
      "error": "Error"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Administrar Operaciones Informes",
      "warning": "Advertencia"
    },
    "label": {
      "operation": "Operación",
      "report": "Informe"
    },
    "header": {
      "operation": "Operación",
      "report": "Informe",
      "actions": "Acciones"
    },
    "messages": {
      "removeReportOperation": "¿Estas seguro de eliminarlo?"
    }
  },
  "report-cells": {
    "title": {
      "page": "Casillas"
    },
    "label": {
      "code": "Código Casilla",
      "name": "Nombre Casilla",
      "description": "Descripción",
      "formula": "Fórmula",
      "order": "Orden",
      "type": "Tipo",
      "numeric": "Numérica",
      "currency": "Moneda",
      "date": "Fecha",
      "list": "Lista",
      "text": "Texto",
      "catalogType": "Tipo Catálogo"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿Está seguro que desea eliminarlo?"
    }
  },
  "reports": {
    "title": {
      "page": "Administrar Informes",
      "report": "Informe",
      "versions": "Versiones"
    },
    "label": {
      "name": "Nombre",
      "rateType": "Tipo Tasa",
      "shortName": "Nombre corto",
      "code": "Código",
      "newButton": "Nuevo",
      "saveButton": "Guardar",
      "tabEditReport": "General",
      "tabPeriodicity": "Periodicidad",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración"
    },
    "header": {
      "code": "Código",
      "name": "Nombre",
      "shortName": "Nombre corto",
      "actions": "Acciones",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración"
    },
    "validations": {
      "shortNameRequired": "El campo nombre corto es requerido",
      "codeRequired": "El campo código es requerido",
      "dateFromRequired": "El campo fecha desde es requerido",
      "dateToRequired": "El campo fecha hasta es requerido",
      "filingDueDayRequired": "El campo día expiración es requerido",
      "periodicityTypeRequired": "El campo tipo periodicidad es requerido"
    },
    "messages": {
      "savedSuccessfully": "Se guardó correctamente",
      "deletedSuccessfully": "Se eliminó correctamente",
      "error": "Error"
    }
  },
  "form-administration": {
    "title": {
      "page": "Administración Formulario para Declaraciones",
      "form": "Formulario",
      "versions": "Versiones"
    },
    "label": {
      "code": "Código",
      "name": "Nombre",
      "shortName": "Nombre corto",
      "tax": "Impuesto",
      "numberModifications": "Número rectificativas",
      "amendmentApprovalRequired": "Rectificativas requieren aprobación",
      "form": "Formulario",
      "versions": "Versiones"
    },
    "header": {
      "actions": "Acciones",
      "code": "Código",
      "name": "Nombre",
      "shortName": "Nombre corto",
      "tax": "Impuesto"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿Estas seguro de eliminarlo?",
      "noCellDefined": "Estimado contribuyente este formulario tiene una definición incompleta, contacte al administrador"
    }
  },
  "taxpayer-alternate-user": {
    "title": {
      "page-add": "Nuevo usuario alternativo",
      "page-list": "Usuarios alternativos"
    },
    "label": {
      "add-user": "Agregar usuario"
    }
  },
  "login": {
    "hero": {
      "title": "Modernización y cooperación para los desafíos de la tributación en la",
      "name": "Economía Digital"
    },
    "block1": {
      "title": "Una Plataforma Estratégica",
      "text": "para Administraciones Tributarias"
    },
    "block2": {
      "title": "Una herramienta eficaz",
      "text": "para gestionar la tributación de empresas sin representación física en la jurisdicción."
    },
    "block3": {
      "title": "Diseñado para facilitar",
      "text": "el registro, la declaración y el pago de tributos por parte de proveedores digitales extranjeros."
    },
    "links": {
      "title": "Más información",
      "link1": "Materiales y procedimientos",
      "link2": "Sobre CIAT",
      "link3": "Sobre PITAA"
    }
  },
  "appMenu": {
    "taxpayer-profile-update": "Actualizar registro",
    "taxpayer-payment-view": "Ver pagos",
    "unsubscribe-request-taxpayer": "Darse de baja",
    "taxpayer-payment-record": "Registro de pago",
    "taxpayer-amending-credit": "Consulta de saldo",
    "security-taxpayer": "Seguridad",
    "apikey": "Api Keys",
    "two-factor-authentication-taxpayer": "Autenticación con Doble Factor",
    "taxpayer-profile": "Perfil",
    "inbox-notifications": "Notificaciones",
    "file-tax-statements": "Presentar declaración de impuestos",
    "statements": "Declaraciones",
    "taxpayer-taxreturn-payments": "Pagos",
    "file-report": "Presentar informe complementario",
    "amendment-taxreturn": "Rectificar declaración",
    "taxpayer-tax-returns": "Consultar declaraciones",
    "taxpayer-report-details": "Consultar informes Complementarios"
  }
}
